import React from 'react';
import { StyledFormWarningLabel } from './styles';

interface IFormLabel {
  label: string;
  name?: string;
  style?: any;
}

const FormWarningLabel = ({ label, name = '', style }: IFormLabel) => (
  <StyledFormWarningLabel style={{ ...style }} htmlFor={name}>
    {label}
  </StyledFormWarningLabel>
);

export default FormWarningLabel;
